import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaPhone, FaEnvelope,FaLinkedin} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import footerlogo from "../media/logo.png";
import "../styles/footer.css"; // Custom styles
function Footer(){
    return(
        <>
            <footer className="footer">
            <Container>
                <Row>
                    <Col className="footer-col">
                        <img className="footerlogo" src={footerlogo} alt="BuildEdge Studios" />
                        <address className="address">
                        <p><FaLocationDot/> Chalakkudy, Thrissur</p>
                        <p><FaPhone /> <a href="tel:918139080779">+91 81390 80779</a></p>
                        <p><FaEnvelope /> <a href="mailto:info@buildedgesolutions.in">info@buildedgestudios.in</a></p>
                        </address>
                        
                        <div className="social-icons">
                            <a href="https://www.facebook.com/buildedgestudios/" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                            <a href="https://x.com/BuildEdgestudio" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
                            <a href="https://www.instagram.com/buildedgestudios" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                            <a href="https://www.linkedin.com/buildedgestudios" className="icon"><FaLinkedin/></a>
                        </div>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col className="footer-page-links">
                        <a href="/">Home</a>
                        <a href="#about">About Us</a>
                        <a href="#services">Our Services</a>
                        <a href="#clients">Clients</a>
                        <a href="#contact">Contact Us</a>
                    </Col>
                    <Col className="text-center rights-reserved">
                        <em>&copy; {new Date().getFullYear()} BuildEdge Studios. All Rights Reserved.</em>
                    </Col>
                </Row>
            </Container>
    
            </footer>
        </>
    )
}

export default Footer;